import { Config } from '@eslint/config-helpers';
import * as FolderLint from '@servicetitan/folder-lint';
import { Rule } from 'eslint';
import memoize from 'lodash/memoize';
import path from 'path';

const checkPath = memoize((configPath: string) =>
    FolderLint.checkPath(require(configPath).default)
);

interface Options {
    config: string;
    docLink?: string;
    root: string;
}

const check: Rule.RuleModule = {
    meta: {
        schema: {
            type: 'array',
            minItems: 1,
            maxItems: 1,
            contains: {
                type: 'object',
                properties: {
                    root: { type: 'string' },
                    config: { type: 'string' },
                    docLink: { type: 'string' },
                },
                required: ['root', 'config'],
            },
        },
    },
    create(context: Rule.RuleContext & { options: Options[] }) {
        const { config, root, docLink } = context.options[0];

        const pathToCheck = path.relative(root, context.getFilename());

        checkPath(config)(pathToCheck).forEach(failure =>
            context.report({
                message: FolderLint.printFailure(failure) + printDetails(docLink),
                loc: {
                    start: { line: 0, column: 0 },
                    end: { line: 0, column: 0 },
                },
            })
        );

        return {};
    },
};

function printDetails(docLink?: string): string {
    return docLink ? ' More details: ' + docLink : '';
}

export const rules = {
    check,
};

const plugin = {
    configs: {
        recommended: ({
            config,
            docLink = 'https://docs.st.dev/docs/frontend/file-structure',
            root = process.cwd(),
        }: {
            config: string;
            docLink?: string;
            root?: string;
        }): Config[] => [
            {
                plugins: {
                    '@servicetitan/folder-schema': { rules },
                },
                rules: {
                    '@servicetitan/folder-schema/check': ['error', { root, config, docLink }],
                },
            },
        ],
    },
};

// eslint-disable-next-line import/no-default-export
export default plugin;
